'use strict';

import $ from 'jquery';
window.jQuery = $;
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'jquery-ui/ui/widgets/autocomplete';
import { lib } from '../../common/Library';
require('../../../vendor/iCheck/icheck.min.js');
require('../../../vendor/iCheck/skins/flat/green.css');

require('webpack-jquery-ui');
require('webpack-jquery-ui/css');
require('../../../vendor/jquery.ui.labeledslider/jquery.ui.labeledslider.min.js');

// PC 共通

$(function () {
    // SP切り替え
    if ($('#sp_transition').length > 0) {
        if(lib.isIpad()) {
            $('#sp_transition').show();
        } else if(lib.isAndroid() || lib.isIphone()) {
            let cookieUa = lib.myGetCookie('USER_AGENT');

            // 初回アクセス時UA情報が無ければspページを表示
            if (cookieUa === null) {
                lib.mySetCookie('USER_AGENT', 'sp', 365);
                location.reload();
            } else {
                $('#sp_transition').show();
            }
        }

        // Cookie情報が無い場合、初期値を入れる
        if (lib.myGetCookie('USER_AGENT') === null) {
            let period = new Date();
            period.setTime(period.getTime() + (365 * 24 * 60 * 60 * 1000));
            lib.mySetCookie('USER_AGENT', 'pc', period.toGMTString());
        }

        $(document).on('click', '#sp_transition', function () {
            let period = new Date();
            period.setTime(period.getTime() + (365 * 24 * 60 * 60 * 1000));
            lib.mySetCookie('USER_AGENT', 'sp', period.toGMTString());

            let url = $(this).data('url');
            if (url !== undefined) {
                location.href = url;
            } else {
                location.reload();
            }
        });
    }
});

/**
 * グラフテーブル開閉処理
 */
$('.table_toggle_btn').on('click', function() {
    //クリックされたクラスを取得
    let thisClasses = $(this).attr('class'),
    //取得したクラスを分割
        thisClassList = thisClasses.split(' '),
    //クリックした場所の親要素
        $parentPerformance = $(this).parent().parent(),
    //リンク文字の切り替え
        $parentTableToggleBtn = $parentPerformance.find('.table_toggle_btn');

    if (thisClassList[1] === 'open') {
        $parentTableToggleBtn.text('折りたたむ');
        $parentTableToggleBtn.removeClass('open');
        $parentTableToggleBtn.addClass('close');
    } else {
        $parentTableToggleBtn.text('展開する');
        $parentTableToggleBtn.removeClass('close');
        $parentTableToggleBtn.addClass('open');
    }

    //テーブル表示トグル
    $($parentPerformance).find('.table_toggle').slideToggle('fast');
});

/**
 * ページトップへスクロール
 */
$('.btn_ptop a').on('click', function() {
    // スクロール
    $('html, body').animate({scrollTop: 10}, 300, 'swing');
});

/**
 * サイドメニューのスクロール位置固定化
 */
$(window).on('load', function() {
    //#main,#subを取得
    let main = $('#main'),
        side = $('#sub_find_group'),
        minMove,
        maxMove,
        marginBottom;

    if (side.length > 0 && main.length > 0) {
        //スクロール開始位置
        minMove = side.offset().top - parseInt(side.css('margin-bottom'));
        //スクロール終了位置 mainの開始位置 + mainの高さ - sideの高さ
        maxMove = main.offset().top + main.height() - side.height();
        //#mainより#subが長い場合、処理しない
        if (maxMove <= minMove) {
            return false;
        }
        marginBottom = maxMove - minMove;
        if (marginBottom < 0) {
            marginBottom = 0;
        }
        // スクロールした時に以下の処理
        $(window).on('scroll', function() {
            moveSideMenu(minMove);
        });
    }
});

function moveSideMenu(minMove) {
    //#main,#subを取得
    let main = $('#main'),
        side = $('#sub_find_group'),
        maxMove,
        marginBottom,
        sideMarginTop = 0,
        scrollTop,
        marginTop;

    //スクロール終了位置 mainの開始位置 + mainの高さ - sideの高さ
    maxMove = main.offset().top + main.height() - side.height();
    //#mainより#subが長い場合、処理しない
    if (maxMove <= minMove) {
        return false;
    }
    marginBottom = maxMove - minMove;
    if (marginBottom < 0) {
        marginBottom = 0;
    }

    scrollTop = $(window).scrollTop();
    if (scrollTop > minMove && scrollTop < maxMove) {
        //固定化開始
        marginTop = scrollTop - minMove;
        side.css({
            'margin-top': marginTop
        });
    } else if (scrollTop < minMove) {
        //一番上 固定化無し
        side.css({
            'margin-top': sideMarginTop
        });
    } else if (scrollTop > maxMove) {
        //一番下
        side.css({
            'margin-top': marginBottom
        });
    }
}

/**
 * タブ切り替え処理
 */
$(document).on('click', '.tab_select:not(.disable) li:not(.disable)', function() {
    //親要素
    let $tabGroup = $(this).closest('.tab_group'),
    //何番目の要素がクリックされたか取得
        clickIdx = $(this).index(),
        tabSwitchingList = $tabGroup.find('.tab_switching');

    if (tabSwitchingList.length === 0) {
        return;
    }

    $tabGroup.find('.tab_select li').removeClass('active');
    $(this).addClass('active');

    $(tabSwitchingList).removeClass('show');
    $(tabSwitchingList[clickIdx]).addClass('show');
});

/**
 *
 */
$(document).on('click', '.sub_tab li', function() {
    //親要素
    let $tabGroup = $(this).closest('.tab_group'),
    //何番目の要素がクリックされたか取得
        clickIdx = $(this).index(),
        subTabSwitchingList = $tabGroup.find('.sub_tab_switching');

    if (subTabSwitchingList.length === 0) {
        return;
    }

    $tabGroup.find('.sub_tab li').removeClass('active');
    $(this).addClass('active');

    $(subTabSwitchingList).removeClass('show');
    $(subTabSwitchingList[clickIdx]).addClass('show');
});

// 銘柄オートコンプリート_自動遷移なし
$(function() {
    //検索結果返却数リミット件数
    let RESULT_LIMIT = 10;
    //検索結果件数が0の時のメッセージ
    let NO_RESULT_MSG = '該当結果なし';
    //検索結果除外フラグ 0:除外しない 1:cookieにある銘柄を除外する
    let EXCLUSION_FLG = '0';
    $('.stock_search').autocomplete({
        source: function(request, response) {
            $.ajax({
                url: $('#routeAjaxSuggest').val(),
                type: 'POST',
                cache: false,
                dataType: 'json',
                data: {
                    searchTerm: request.term
                }
            })
            .done(function(ret) {
                //検索結果件数が0の時
                if (ret.length === 0) {
                    response([NO_RESULT_MSG]);
                    return;
                }
                response(ret);
            })
            .fail(function(jqXHR, textStatus, errorThrown) {
                response(['']);
            });
        },
        autoFocus: false,
        delay: 200,
        minLength: 1,
        select: function(ev, ui) {
            let searchVal = ui.item.value;

            //検索候補が無いとき、入力欄を削除
            if (searchVal === NO_RESULT_MSG) {
                ui.item.value = '';
                return;
            }
            if (searchVal.match(/\(([0-9A-Za-z]+)\)/)[1] !== undefined) {
                let stockCd = searchVal.match(/\(([0-9A-Za-z]+)\)/)[1];
                ui.item.value = stockCd;
            }
        }
    });
});

// 銘柄オートコンプリート_自動遷移あり
$(function() {
    //検索結果返却数リミット件数
    let RESULT_LIMIT = 10;
    //検索結果件数が0の時のメッセージ
    let NO_RESULT_MSG = '該当結果なし';
    //検索結果除外フラグ 0:除外しない 1:cookieにある銘柄を除外する
    let EXCLUSION_FLG = '0';
    $('.stock_search_auto').autocomplete({
        source: function(request, response) {
            $.ajax({
                url: $('#routeAjaxSuggest').val(),
                type: 'POST',
                cache: false,
                dataType: 'json',
                data: {
                    searchTerm: request.term
                }
            })
            .done(function(ret) {
                //検索結果件数が0の時
                if (ret.length === 0) {
                    response([NO_RESULT_MSG]);
                    return;
                }
                response(ret);
            })
            .fail(function(jqXHR, textStatus, errorThrown) {
                response(['']);
            });
        },
        autoFocus: false,
        delay: 200,
        minLength: 1,
        select: function(ev, ui) {
            let searchVal = ui.item.value;

            //検索候補が無いとき、入力欄を削除
            if (searchVal === NO_RESULT_MSG) {
                ui.item.value = '';
                return;
            }
            if (searchVal.match(/\(([0-9A-Za-z]+)\)/)[1] !== undefined) {
                let stockCd = searchVal.match(/\(([0-9A-Za-z]+)\)/)[1];
                //redirect
                window.location.href = $('#routeFind').val() + '/' + stockCd;
            }
        }
    });
});

/**
 * 選択タブ用の機能制限メッセージバルーン出力
 */
// 共通
$(function() {
    const element = '.limit';
    const options = {
        content: 'マネックス証券に口座開設して銘柄スカウターをご利用いただくと無料でご覧いただけます。'
    };

    tippy(element, options);
});

// グラフ用（期間選択ボタン）
window.setBalloonForGraph = function() {
    const element = '.highcharts-button-disabled text';
    const options = {
        content: 'マネックス証券に口座開設して銘柄スカウターをご利用いただくと無料でご覧いただけます。'
    };

    tippy(element, options);
}

// 個別 企業分析
$(function() {
    const element = '.limit_zaimu_fy_cf';
    const options = {
        content: 'マネックス証券に口座開設して銘柄スカウターをご利用いただくと無料で最長で2007年以降のすべての期間の業績をご覧いただけます。'
    };

    tippy(element, options);
});

// 個別 企業分析
$(function() {
    const element = '.limit_zaimu_4q';
    const options = {
        content: 'マネックス証券に口座開設して銘柄スカウターをご利用いただくと無料で最大20四半期分のすべての期間の業績をご覧いただけます。'
    };

    tippy(element, options);
});

// グローバル スクリーニング
$(function() {
    const element = '.limit_screening';
    const options = {
        content: 'マネックス証券に口座開設して銘柄スカウターをご利用いただくと、すべての詳細条件から最大10個までお選びいただけます。'
    };

    tippy(element, options);
});

//open help window
window.open_help = function(num, pos) {
    let filename = '/help/pc/h' + num + '.html' + '#' + pos;
    window.open(filename, 'help', 'width=920,height=600,menubar=no,toolbar=no,resizable=yes,scrollbars=yes');
}
